/** Saved formal identity for Admin page headings and history context. */
export interface PersonIdentity {
  firstName?: string | null
  lastName?: string | null
  email?: string
}

export function personLabel(person: PersonIdentity | undefined): string | undefined {
  if (!person) return undefined
  const first = person.firstName?.trim() ?? ''
  const last = person.lastName?.trim() ?? ''
  // Mirrors the API formal-name rule, independent of script or UI language.
  const parts = [last, first]
  return parts.filter(Boolean).join(' ') || person.email || undefined
}
